import axios from 'axios';

export interface CibaCompleteLoginInput {
  authReqId: string;
  completionToken: string;
}

export type CibaCompleteLoginResult =
  | 'completed'
  | 'pending'
  | 'slow_down'
  | 'denied'
  | 'expired'
  | 'failed';

interface CibaCompleteLoginResponse {
  status?: string;
}

function mapCompleteStatus(
  httpStatus: number,
  responseStatus: string | undefined
): CibaCompleteLoginResult {
  if (responseStatus === 'ok') return 'completed';
  if (responseStatus === 'approved') return 'completed';
  if (responseStatus === 'success') return 'completed';
  if (responseStatus === 'completed') return 'completed';
  if (responseStatus === 'pending') return 'pending';
  if (responseStatus === 'slow_down') return 'slow_down';
  if (responseStatus === 'denied') return 'denied';
  if (responseStatus === 'expired') return 'expired';
  if (responseStatus === 'error') return 'failed';

  if (httpStatus === 200) return 'completed';
  if (httpStatus === 202) return 'pending';
  if (httpStatus === 429) return 'slow_down';
  if (httpStatus === 403) return 'denied';
  if (httpStatus === 410) return 'expired';

  return 'failed';
}

export async function completeCibaLogin({
  authReqId,
  completionToken,
}: CibaCompleteLoginInput): Promise<CibaCompleteLoginResult> {
  const { status, data } = await axios.post<CibaCompleteLoginResponse>(
    '/api/auth0/ciba-complete',
    {
      auth_req_id: authReqId,
      completion_token: completionToken,
    },
    {
      validateStatus: () => true,
    }
  );

  return mapCompleteStatus(status, data?.status);
}
